import React, { useState } from 'react';
import { Container } from '@/components';
import { motion } from 'framer-motion';
import UploadProductFile from './UploadProductFile';
import PromoPrice from './PromoPrice';
import NewProductCode from './NewProductCode';
import NewItemCondition from './NewItemCondition';

const options = [
  'Products',
  'Promo Price',
  'New Product Code',
  'New Item Condition',
];

const Components = {
  Products: () => <UploadProductFile />,
  'Promo Price': () => <PromoPrice />,
  'New Product Code': () => <NewProductCode />,
  'New Item Condition': () => <NewItemCondition />,
};

const ManageProductFile = () => {
  const [selectedOption, setSelectedOption] = useState('Products');
  const SelectedComponent = Components[selectedOption];

  return (
    <Container title="Manage Product File">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto p-8 bg-white shadow-lg rounded-xl border border-gray-200 my-10"
      >
        <div className="flex border-b mb-6">
          {options.map((option) => (
            <motion.div
              key={option}
              onClick={() => setSelectedOption(option)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className={`cursor-pointer px-6 py-3 text-md font-semibold transition duration-300 ${selectedOption === option ? 'border-b-4 border-blue-700 text-blue-700' : 'text-gray-500 hover:text-gray-700'}`}
            >
              {option}
            </motion.div>
          ))}
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          className="p-6 border rounded-lg bg-gray-50 shadow-sm"
        >
          <SelectedComponent />
        </motion.div>
      </motion.div>
    </Container>
  );
};

export default ManageProductFile;
